import ComponentsCollection from './components-collection';
import $ from 'jquery';
import Modernizr from 'imports-loader?this=>window!exports-loader?Modernizr!./modernizr-build';
import eventBus from './event-bus';

export const DEVICE_TYPE_DESKTOP = 'desktop';
export const DEVICE_TYPE_TABLET = 'tablet';
export const DEVICE_TYPE_MOBILE = 'mobile';

export const EVENT_DEVICE_TYPE_CHANGED = 'device-type-changed';
export const EVENT_RESIZE_FINISHED = 'resize:finished';
export const EVENT_AUTH_TRIGGER_CLICK = 'auth:trigger-click';

class App {
    constructor() {
        this.componentsCollection = ComponentsCollection.getInstance();
        this.resizeDebounceTime = 150;
        this.timeoutId = null;
        this.isTouch = Modernizr.touchevents;
        this.config = window.appConfig || {};
    }

    init() {
        this.$window = $(window);
        this.applyViewportData();
        this.$window.on('resize orientationchange', this.onWindowResize.bind(this));

        this.componentsCollection.init();
    }

    applyViewportData() {
        this.viewport = {
            width: this.$window.outerWidth(),
            height: this.$window.outerHeight(),
            orientation: typeof window.orientation === "undefined" || Math.abs(window.orientation) === 90 ? "landscape" : "portrait"
        };
        this.isDesktop = Modernizr.mq('only screen and (min-width:1024px)');
        if (this.isDesktop) {
            this.isTablet = true;
        } else {
            this.isTablet = Modernizr.mq('only screen and (min-width:768px)');
        }
        this.deviceTypeByViewport = this.isDesktop ? DEVICE_TYPE_DESKTOP : (this.isTablet ? DEVICE_TYPE_TABLET : DEVICE_TYPE_MOBILE);
    }

    onWindowResize() {
        if (this.timeoutId !== null) {
            clearTimeout(this.timeoutId);
        }
        this.timeoutId = setTimeout(this.handleWindowResize.bind(this), this.resizeDebounceTime);
    }

    handleWindowResize() {
        let oldDeviceType = this.deviceTypeByViewport;
        this.applyViewportData();
        eventBus.emit(EVENT_RESIZE_FINISHED);
        if (oldDeviceType !== this.deviceTypeByViewport) {
            eventBus.emit(EVENT_DEVICE_TYPE_CHANGED, oldDeviceType, this.deviceTypeByViewport);
        }
    }

    getConfig(property, defaultValue = undefined) {
        if (!(property in this.config) && defaultValue === undefined) {
            throw new Error(`cannot find a property «${property}» in config and default value is absent`)
        }
        return property in this.config ? this.config[property] : defaultValue;
    }
}

let instance = new App();
export default instance;



// WEBPACK FOOTER //
// ./app/general/js/app.js